import { createAction } from 'redux-actions';
export const setCurrency = createAction('SET_CURRENCY');